/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ConsultaHistoricoInclusaoBeneficiarioAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AUTOCOMPLETE_TIPO = 'autocomplete-tipo',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK_0 = 'deck-0',
  FETCH_0 = 'fetch-0',
  FETCH_CONSULTA = 'fetch-consulta',
  FETCH_TIPO = 'fetch-tipo',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_DT_LIBERACAO_SOLIC_INCLUSAO = 'field-dtLiberacaoSolicInclusao',
  FIELD_DT_SOLICITACAO = 'field-dtSolicitacao',
  FIELD_LOTE = 'field-lote',
  FIELD_MOTIVO = 'field-motivo',
  FIELD_NM_BENEFICIARIO = 'field-nmBeneficiario',
  FIELD_NR_SEQ_LOTE = 'field-nrSeqLote',
  FIELD_TIPO = 'field-tipo',
  FILTER_CONSULTA = 'filter-consulta',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  INPUT_LOTE = 'input-lote',
  LAYOUT_1 = 'layout-1',
  MAPPER_0 = 'mapper-0',
  MAPPER_TIPO = 'mapper-tipo',
  MODAL_REJEICAO = 'modal-rejeicao',
  PANEL_3 = 'panel-3',
  PANEL_INCLUSAO_BENEFICIARIO = 'panel-inclusao-beneficiario',
  PANEL_MODAL = 'panel-modal',
  PANEL_STAMP = 'panel-stamp',
  RENDER_STATUS = 'render-status',
  STAMP_SITUACAO_LOTE = 'stamp-situacao-lote',
  TEXT_1 = 'text-1',
  TEXT_DT_LIBERACAO_SOLIC_INCLUSAO = 'text-dtLiberacaoSolicInclusao',
  TEXT_DT_SOLICITACAO = 'text-dtSolicitacao',
  TEXT_MOTIVO = 'text-motivo',
  TEXT_NM_BENEFICIARIO = 'text-nmBeneficiario',
  TEXT_NR_SEQ_LOTE = 'text-nrSeqLote',
  TEXT_TIPO = 'text-tipo',
}
export { ConsultaHistoricoInclusaoBeneficiarioAliases };
